(function (w, d) {
  'use strict';

  function init() {
    var inventory = w.WPRxFrameInventory;
    if (!inventory) return;

    var ctas = d.querySelectorAll('[data-rx-pdp-cta]');
    Array.prototype.forEach.call(ctas, function (cta) {
      var form = cta.closest('form');
      var configNode = form && form.querySelector('[data-rx-pdp-product]');
      if (!form || !configNode) return;

      var product;
      try { product = JSON.parse(configNode.textContent); }
      catch (e) { cta.hidden = true; return; }

      // Build Your Own Pair is always offered: an in-stock frame deep-links into a new pair
      // with that frame preselected; otherwise (sold out, or on preorder: inStock false) the
      // builder opens at the start, where the customer can still re-lens a pair they own.
      // The theme's variant-change event carries Shopify's variant object, so stock is read
      // from this product's JSON by id.
      function inStock(variant) {
        var own = (product.variants || []).find(function (v) { return String(v.id) === String(variant.id); });
        return (own || variant).inStock !== false;
      }
      function update(variant) {
        var rxHandle = variant && variant.available && inStock(variant)
          ? inventory.rxHandleForVariant(product.handle, variant)
          : null;
        cta.hidden = false;
        cta.href = rxHandle
          ? '/pages/prescription-lenses?frame=' + encodeURIComponent(rxHandle) + '&start=1'
          : '/pages/prescription-lenses';
      }

      var select = form.querySelector('select[name="id"]');
      var selectedId = select && select.value;
      var selected = (product.variants || []).find(function (variant) {
        return String(variant.id) === String(selectedId);
      });
      update(selected || null);

      d.addEventListener('wp:variant-change', function (event) {
        update(event.detail && event.detail.variant || null);
      });
    });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})(window, document);
